var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.148 11.463-7.84-7.838a.666.666 0 0 0-.93 0L18.83 5.173l6.292 6.29a.666.666 0 0 1 0 .929l-6.485 6.483 1.548 1.548a.666.666 0 0 0 .93 0l8.014-8.012a.672.672 0 0 0 .019-.948Z",
    fill: "#009C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.791 4.208-.561-.561a.666.666 0 0 0-.93 0l-1.548 1.548 1.026 1.026 2.013 2.012 2.014-2.012-2.014-2.013ZM15.614 15.856 13.6 17.87l-1.026 1.026 1.549 1.548a.667.667 0 0 0 .93 0l.56-.561 2.014-2.013-2.013-2.013Z",
    fill: "#40E3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.059 11.465a.666.666 0 0 1 0 .929l-3.446 3.444 2.014 2.013 5.458-5.457a.666.666 0 0 0 0-.93L17.82 6.202l-2.033 2.013 3.272 3.25Z",
    fill: "#1ABAB8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.267 11.656 11.726 6.2 9.713 4.186l-.581-.56a.666.666 0 0 0-.93 0L.19 11.655a.666.666 0 0 0 0 .93l7.84 7.837a.666.666 0 0 0 .929 0l.58-.561 2.014-2.013-5.266-5.264c-.27-.251-.27-.658-.019-.929Z",
    fill: "#87F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m12.34 11.659 2.4-2.4-2.013-2.013L11.7 6.221l-5.42 5.457a.666.666 0 0 0 0 .929l5.246 5.244 1.025-1.025 2.014-2.013-2.227-2.226c-.251-.232-.251-.657 0-.928Z",
    fill: "#40E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12.348 12.584 2.226 2.226 2.401-2.4a.666.666 0 0 0 0-.929L14.75 9.256l-2.4 2.4a.706.706 0 0 0 0 .928Z",
    fill: "#17CFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.2e8e89b8da0c2b1c7fbb8bc259c0d6f9.svg";
export { ForwardRef as ReactComponent };